import { useEffect, useState } from "react";
import MarkdownIt from "markdown-it";

import { Layout } from "../../../components";
import { getPages } from "../api";


const Terms_Conditions = () => {
    const [termsConditions, setTermsConditions] = useState<string>('');

    const mdParser = new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true,
    });

    useEffect(() => {
        getPages({type:2}).then(res => {
            setTermsConditions(res.data.data.content);
        })
        window.scrollTo(0, 0);
    }, [])

    return (
        <Layout>
            <div className="container">
                <h3 className="text-center mt-5 mb-3">Terms & Conditions </h3>
                <div
                    // className="mb-5"
                    // dangerouslySetInnerHTML={{
                    //     __html: mdParser.render(termsConditions),
                    // }}
                />
                 <p>
        By using our website or mobile application, you are entering into a legally binding agreement with TravelX. These Terms and Conditions outline the terms of your access and usage of our application. We encourage you to carefully review these terms to ensure a mutual understanding between us.
      </p>

      <p>
        To access the Application, it is essential that you acknowledge and accept our Terms and Conditions of Use. By doing so, you demonstrate your understanding and agreement with these terms. However, if you disagree with any of these conditions, we kindly request that you refrain from using the application and discontinue its use promptly.
      </p>

      <p>
        To ensure transparency and clarity, we want to inform you that there may be additional terms and conditions or documents that are periodically shared on the Application. These supplemental materials are just as important as the Terms and Conditions mentioned above and should be considered as an integral part of your agreement with us.
      </p>

      <p>
        Rest assured that we have the ultimate authority to make changes or updates to these Terms and Conditions. This gives us the flexibility and adaptability to ensure our policies are in line with any evolving circumstances or reasons that may arise. Rest assured, we will keep you informed about any modifications to these Terms and Conditions. By simply updating the “Last updated” date, you will be promptly notified of any changes. You can rely on this method instead of expecting specific notices for each alteration.
      </p>

      <p>
        Ensuring that you are up-to-date with any updates to the Terms and Conditions is crucial, and it falls under your responsibility. It’s important to regularly review these terms so that you stay informed and aware of any changes that may affect you.
      </p>

      <p>
        By continuing to use the Application after revised Terms and Conditions are posted, you will be automatically subjected to and considered fully informed about any changes that have been made. It is important to note that your acceptance of these changes is implied.
      </p>

      <p>
        Our top priority is to ensure that our service complies with all applicable laws and regulations. Therefore, it is crucial to note that the use of our application is strictly intended for individuals and entities in jurisdictions or countries where it aligns with the legal requirements. We strongly advise against using our service in any jurisdiction or country where it would be considered unlawful or against regulations.
      </p>

      <p>
        By accessing the Application from different locations, individuals take their own initiative and are fully accountable for complying with relevant local laws, if and when they apply.
      </p>

      <h2>eSIM Service</h2>
      <p>
        <a href="https://www.travelvip.ai/" target="_blank" rel="noopener noreferrer">www.TravelX.com</a> (TravelX) sells prepaid eSIM with data service plans based on eSIM technology (the “Service”). TravelX may be reselling the Service through a Partner or an Agent.
      </p>

      <h2>Terms of Service</h2>

      <h3>Registration</h3>
      <ul>
        <li>
          Registering for our Service has never been difficult! Customers have multiple options to choose from when signing up. They can conveniently register through our user-friendly website, access our TravelX App, or even register with the help of other trusted partners or agents. We aim to provide a seamless and hassle-free registration process for all of our valued customers.
        </li>
        <li>
          To fully enjoy the benefits of registration, customers are kindly asked to provide essential details. This includes their First and Last name, as well as a verifiable email address. For added personalization, customers also have the option to upload a profile photo and share their travel preferences. Rest assured, providing this information is entirely voluntary and helps us tailor our services to meet your unique needs.
        </li>
        <li>
          To register for the service, customers must accept both the General Terms and Conditions, as well as the Privacy Policies. By doing so, customers ensure that they are fully informed about their rights and responsibilities, while also maintaining their privacy and data security.
        </li>
      </ul>

      <h3>Purchase and Activation</h3>
      <ol>
        <li>
          TravelX may limit the availability of plans to specific countries. Rest assured, our website, TravelX app, and trusted partners and agents are all equipped with easy-to-use search and purchase functionalities. This gives you the freedom to explore, select, and buy the perfect plan that suits your needs without any hassle.
        </li>
        <li>
          When customers choose to purchase our Service, they are confirming that they already possess an unlocked and eSIM-compatible device, as this is a necessary requirement to fully enjoy the benefits of our Service.
        </li>
        <li>
          After making a purchase, it is important for customers to download the eSIM onto their device. This step ensures that the data plans are properly configured according to your order specifications. The best part is that once downloaded, the eSIM remains on your device even after your credit has been used up or your plan has expired.
        </li>
        <li>
          Customers have the flexibility to remove the eSIM in their phone settings whenever they please. However, we highly recommend that customers refrain from removing the eSIM until their plan has been fully utilized or expired. This will ensure a seamless and uninterrupted experience throughout their plan duration.
        </li>
        <li>
          In order to enjoy our services, customers are required to follow a simple process. Firstly, they need to download the eSIM onto their device. Once that’s done, activating the data plan attached to the eSIM will initiate the service. It’s worth noting that a stable internet connection is essential for a smooth downloading and activation experience. Rest assured, we are here to assist you every step of the way.
        </li>
      </ol>
            </div>
        </Layout>
    );
};

export default Terms_Conditions;